import {getLocale} from "app/helpers/session";

export default function formatNumber(num) {
    if (!num) {
        return num
    }
    const locale = getLocale().replace('_', '-')

    if (typeof num == "string") {
        num = num.replace(/,/g, '.')
        num = parseFloat(num)
    }

    if (!num) {
        return ''
    }
    num = num.toLocaleString(locale).replace(/\./g, ',');

    return num;
}